import { hexToRGB } from '@repo-level/core-front';
import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components';
import bgImage from '../../../../../assets/images/clover-gold/bg-panel.webp';

interface IScCloverGoldPanelProps {
  $isAuthenticated: boolean;
}

export const ScCloverGoldPanel = styled.div<IScCloverGoldPanelProps>`
  background: url(${bgImage}) center / cover no-repeat;
  background-color: #323444;
  border-radius: 8px;
  padding: ${({ $isAuthenticated }) =>
    $isAuthenticated ? '11px 8px 7px 8px' : '15px 12px'};
  cursor: pointer;
  display: flex;
  gap: 8px;
  @media (${device.mobile}) {
    border-radius: 16px;
    padding: 12px;
  }

  .inner {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;

    @media (${device.mobile}) {
      flex-direction: row;
      align-items: center;
    }

    svg {
      margin-left: auto;
      path {
        fill: ${({ theme }) => hexToRGB(theme.whiteColor, 0.4)};
      }
    }

    .content {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 8px;
      @media (${device.mobile}) {
        gap: 0px;
      }
      .title-wrapper {
        display: flex;
        align-items: center;
        gap: ${({ $isAuthenticated }) => ($isAuthenticated ? '10px' : '2px')};

        .title {
          font-size: 12px;
          line-height: 18px;
          font-weight: 700;

          @media (${device.mobile}) {
            font-size: 14px;
            line-height: 20px;
            color: ${({ theme }) => theme.whiteColor};

            display: ${({ $isAuthenticated }) =>
              $isAuthenticated ? 'block' : 'none'};
          }
        }
      }

      .progress {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;

        .progress-value {
          font-size: 12px;
          line-height: 18px;
          font-weight: 700;
          display: inline;
          .your-progress {
            display: none;
          }

          @media (${device.mobile}) {
            font-size: 14px;
            line-height: 20px;
            font-weight: 400;
            color: ${({ theme }) => theme.whiteColor};

            .your-progress {
              display: inline;
            }
          }
        }

        @media (${device.mobile}) {
          flex-direction: column-reverse;
          align-items: flex-start;
        }
      }

      .description {
        font-size: 10px;
        line-height: 14px;
        font-weight: 700;
        text-align: center;

        @media (${device.mobile}) {
          font-size: 14px;
          line-height: 20px;
          color: ${({ theme }) => theme.whiteColor};
          text-align: start;
        }
      }
    }
  }
`;
